const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_id'];

export function resolveUTMAttribution() {
    const urlParams = new URLSearchParams(window.location.search);
    const hasURLAttribution = utmKeys.some(key => urlParams.has(key));
    const values = {};

    for (const key of utmKeys) {
        const rawValue = hasURLAttribution ? urlParams.get(key) : $.cookie(key);
        let value = typeof rawValue === 'string' ? rawValue.trim() : '';
        if (!hasURLAttribution && (value === 'null' || value === 'undefined')) {
            value = '';
        }
        values[key] = value;
    }

    return { hasURLAttribution, values };
}

export function persistUTMAttribution(attribution) {
    if (!attribution.hasURLAttribution) return;

    const options = { expires: 14, path: '/' };
    const hostname = window.location.hostname;
    if (hostname === 'ddi.com' || hostname.endsWith('.ddi.com')) {
        options.domain = '.ddi.com';
    }

    for (const key of utmKeys) {
        $.cookie(key, attribution.values[key], options);
    }
}
